/* app/controls/control.product-filters */

//import { GoogleMapUtil } from 'Util/util.google-map';

let selectors = {
	container: '.js-product-listing-filter',
	filterToggler: '.js-product-filters__toggle',
	filterTogglerText: '.js-product-filters__toggle-text',
	filterTogglerIcon: '.js-product-filters__toggle-icon',
	filterGroup: '.js-product-filters__group',
	filterForm: '.js-product-filters-form',
};

let $container;
let $filterToggler;
let $filterTogglerText;
let $filterTogglerIcon;
let $filterGroup;
let $filterForm;

const module = {
	init: function () {
		module._initElement();
		module._detectLargeFilterGroups();
		module._bindEvents();
	},

	_initElement: function () {
		$container = document.querySelector(selectors.container);
		$filterToggler = document.querySelectorAll(selectors.filterToggler); // Changed to querySelectorAll
		$filterTogglerText = document.querySelector(selectors.filterTogglerText);
		$filterTogglerIcon = document.querySelector(selectors.filterTogglerIcon);
		$filterGroup = document.querySelectorAll(selectors.filterGroup);
		$filterForm = document.querySelector(selectors.filterForm);
	},

	_bindEvents: function () {
		$filterToggler.forEach(toggler => {
			toggler.addEventListener('click', module._toggleFilters);
		});
	},


	// Make large groups 2 wide
	_detectLargeFilterGroups: function () {
		$filterGroup.forEach(ul => {
			const listLength = ul.querySelectorAll('li').length;
			if (listLength > 10) {
				ul.classList.add("c-product-filters-form__group--large");
			} else {
				ul.classList.remove("c-product-filters-form__group--large");
			}
		});
	},

	_toggleFilters: function () {
		$filterForm.classList.toggle('is-showing');
		const isShowing = $filterForm.classList.contains('is-showing');

		$filterTogglerIcon.classList.toggle('iconf-arrow-down', !isShowing);
		$filterTogglerIcon.classList.toggle('iconf-arrow-up', isShowing);

		$filterTogglerText.textContent = isShowing ? 'Close Filter' : 'Open Filter';

		// Scroll the container to the top smoothly
		if ($container) {
			const rect = $container.getBoundingClientRect();
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			const targetY = rect.top + scrollTop - 40;
			window.scrollTo({ top: targetY, behavior: 'smooth' });
		}
	}
};

export { module as ProductFilters };
